import serializeArray from './serialize-array';

export default function reduceFormData(form) {
  return serializeArray(form).reduce((_obj, item) => {
    const obj = _obj;
    obj[item.name] = item.value;
    return obj;
  }, {});
}
